import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        step: '=',
        summary: '=',
        update: '&'
    },
    template: `
        <div class="modal-body">
            <modals-question-import-steps step="vm.step"/>
            <div class="alert alert-success">
                <p>{{ 'general.Import was successful' | translate }}</p>
            </div>
            <div class="form">
                <div class="row">
                    <span class="label">{{ 'general.Questions added' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.summary.imported }}</span></div>
                </div>
                <div class="row">
                    <span class="label">{{ 'general.Questions updated' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.summary.updated }} <small>{{ 'general.Questions with such name existed' | translate }}</small></span></div>
                </div>
                <div class="row">
                    <span class="label">{{ 'general.Questions not added' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.summary.skipped }}</span></div>
                </div>
                <div class="row">
                    <span class="label">{{ 'general.Rows with errors' | translate }}</span>
                    <div class="items"><span class="text">{{ vm.summary.failed }}</span></div>
                </div>
            </div>
        </div>
        <div class="modal-footer" >
            <ul class="actions01">
                <li class="f-right"><button class="btn discrete" type="button" ng-click="vm.update()">{{ 'general.Ok' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {

}



// WEBPACK FOOTER //
// ./src/app/components/modals/question/import/summary/index.js